import { createSelector } from '@ngrx/store';
import { SelectSupplierModuleState } from '../suppliermodule.selector';

export const SelectLoanerWheelInventoryState = createSelector(SelectSupplierModuleState, state => state.LoanerWheelInventoryState);

export const SelectModelTypes = createSelector(SelectLoanerWheelInventoryState, state => state && state.modelTypes);
export const SelectTireSizes = createSelector(SelectLoanerWheelInventoryState, state => state && state.tireSize);
export const SelectProviderLocations = createSelector(SelectLoanerWheelInventoryState, state => state && state.providerLocation);
